import { render, staticRenderFns } from "./ModalEliminarMultiplesDocumentos.vue?vue&type=template&id=4ee81584&scoped=true"
import script from "./ModalEliminarMultiplesDocumentos.vue?vue&type=script&lang=js"
export * from "./ModalEliminarMultiplesDocumentos.vue?vue&type=script&lang=js"
import style0 from "./ModalEliminarMultiplesDocumentos.vue?vue&type=style&index=0&id=4ee81584&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee81584",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ee81584')) {
      api.createRecord('4ee81584', component.options)
    } else {
      api.reload('4ee81584', component.options)
    }
    module.hot.accept("./ModalEliminarMultiplesDocumentos.vue?vue&type=template&id=4ee81584&scoped=true", function () {
      api.rerender('4ee81584', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/repositorio/ModalEliminarMultiplesDocumentos.vue"
export default component.exports